<template>
  <!-- eslint-disable max-len -->

  <svg
    xmlns="http://www.w3.org/2000/svg"
    :style="`height: ${height}px; width: ${width}px;`"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      id="+"
      d="M6.78261 5.69368H11.9526V7.30632H6.78261V12.5H5.16996V7.30632H0V5.69368H5.16996V0.5H6.78261V5.69368Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgPlusIcon',
  props: {
    height: {
      type: Number,
      default: 12,
    },
    width: {
      type: Number,
      default: 12,
    },
    color: {
      type: String,
      default: 'black',
    },
  },
};
</script>
